import { PageFile } from './page-file.model';

export interface IVisitDocumentPage {
  blobId?: string;
  name?: string;
  type?: string;
  //frontend only
  pageFile?: PageFile;
}

export class VisitDocumentPage implements IVisitDocumentPage {
  blobId: string;
  name: string;
  type: string;
  //frontend only
  pageFile?: PageFile;

  constructor(clone: IVisitDocumentPage = null) {
    this.blobId = '';
    this.name = '';
    this.type = '';
    this.pageFile = new PageFile();

    if (clone) {
      this.blobId = clone.blobId;
      this.name = clone.name;
      this.type = clone.type;
      this.pageFile = clone.pageFile;
    }
  }
}
